module.exports = __webpack_public_path__ + "static/p1-602c1469b0f07f2e922b23d7e75dce77.png";